import React from "react"
import styled from "styled-components"
import Image, { GatsbyImageProps } from "gatsby-image"

import Card from "react-bootstrap/Card"
import { IEvent } from "../../../../types/event"
import { microWhite, playRound } from "../../../../assets"

const CardContent = `  
  background: var(--color-green);
  color: var(--color-light);
  border: none;
  display: flex;
  justify-content: space-between;
    padding: 10px 15px;

  p {
    margin: 0;
  }
`

const CardHeader = styled(Card.Header)`
  ${CardContent}

  .icon {
    width: 20px;
  }

  .icon-radio {
    width: 8px;
    transform: translateY(-4px);
    margin-right: 4px;
  }
`

const CardBody = styled(Card.Body)`
  background: var(--color-green);
  padding: 5px 15px;
`

const CardFooter = styled(Card.Footer)`
  ${CardContent}

  .type {
    font-family: var(--font-secondary);
    font-size: var(--font-size-sm);
    text-transform: capitalize;
    font-style: italic;
  }
`

const CardWrapper = styled(Card)`
  margin-bottom: auto;
`

const CardTitle = styled(Card.Title)`
  font-size: var(--font-size-md);
`

const CardLink = styled(Card.Link)`
  color: black;

  &:hover {
    text-decoration: underline;
    color: var(--color-green);
    opacity: 0.7;

    img {
      opacity: 0.7;
    }
  }
`
const CardLinkWhite = styled(CardLink)`
  color: var(--color-white);

  &:hover {
    color: var(--color-white);
  }
`
const CardLinkBlack = styled(CardLink)`
  color: var(--color-dark);

  &:hover {
    color: var(--color-dark);
    text-decoration: none;

    div {
      opacity: 0.7;
    }
  }
`
const CardImage = styled(Image)`
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
`

interface IProps {
  item: IEvent
}

const RadioCard = ({ item }: IProps) => {
  const itemImg = item.img as GatsbyImageProps

  return (
    <CardWrapper>
      {item.img && (
        <CardLink href={item.href} target="_blank">
          <CardImage fluid={itemImg.fluid} />
        </CardLink>
      )}

      <CardHeader>
        <CardLinkWhite href={item.href} target="_blank">
          <Card.Text>
            <img
              className="icon-radio"
              src={microWhite}
              alt="micro"
            />
            radio georges
          </Card.Text>
        </CardLinkWhite>

        <img className="icon" src={playRound} alt="play" />
      </CardHeader>

      <CardBody>
        <CardLinkBlack href={item.href} target="_blank">
          <CardTitle>{item.text}</CardTitle>
        </CardLinkBlack>
      </CardBody>

      <CardFooter>
        <CardLinkWhite href={item.href} target="_blank">
          <Card.Text className="type">{item.category}</Card.Text>
        </CardLinkWhite>
        <Card.Text className="date">{item.date}</Card.Text>
      </CardFooter>
    </CardWrapper>
  )
}

export default RadioCard
